import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActiveErrorResponse } from '@vi-iot/client';

@Component({
  selector: 'app-search-result-active-errors-popup',
  templateUrl: './search-result-active-errors-popup.component.html',
  styleUrls: ['./search-result-active-errors-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultActiveErrorsPopupComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { errors: ActiveErrorResponse[] }
  ) {}
}
